import React, { useEffect, useState } from "react";
import Sidebaar from "../Component/Sidebar";
import TitleComp from "../Component/TitleComp";
import axios from "axios";
import { DataGrid } from "@mui/x-data-grid";
import { Box } from "@mui/material";

import { Button, Col, Form, FormGroup, Modal } from "react-bootstrap";
import { Base_Url } from "../BaseUrl";
import { Bars } from "react-loader-spinner";
import Select from "react-select";
import { ToastContainer, toast } from "react-toastify";
import { compressImage } from "../Component/CompressImage";

function FrameCategory() {
  const [categories, setCategories] = useState([]);
  const [name, setname] = useState("");
  const [file, setfile] = useState(null);
  const [idindex, setidindex] = useState("");
  const [editimg, seteditimg] = useState("");
  const [loading, setloading] = useState(false);
  const [catdata, setCatdata] = useState([]);
  const [selectedOptions, setSelectedOptions] = React.useState([]);
  const [activeBrand, setActiveBrand] = useState(null);
  const [filteredCategories, setFilteredCategories] = useState([]);

  const [imageurl, setimageurl] = useState("")


  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = (e, value) => {
    setShow(true)
    setimageurl(value)
  };

  // Handler for handling changes in selected values
  const handleSelectChange = (selectedValues) => {
    setSelectedOptions(selectedValues);
  };

  let token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  // const handlesubmit = (e) => {
  //   setloading(true);
  //   e.preventDefault();

  //   let formdata = new FormData();

  //   formdata.append("name", name);
  //   if (file) {
  //     formdata.append("image", file);
  //   }
  //   formdata.append("category", selectedOptions.value);
  //   if (idindex) {
  //     formdata.append("_id", idindex);
  //     axios
  //       .put(`${Base_Url}/frame_categories`, formdata, { headers })
  //       .then((res) => {
  //         // console.log(res);
  //         if (res.data !== null) {
  //           setloading(false);
  //           catgoryget();
  //           handleclear();
  //         }
  //       });
  //   } else {
  //     axios
  //       .post(`${Base_Url}/frame_categories`, formdata, { headers })
  //       .then((res) => {
  //         // console.log(res);
  //         if (res.data !== null) {
  //           setloading(false);
  //           catgoryget();
  //           handleclear();
  //         }
  //       });
  //   }
  // };
  // convert this also


  const handlesubmit = (e) => {
    setloading(true);
    e.preventDefault();

    let formdata = new FormData();

    formdata.append("name", name);
    if (file) {
      compressImage(file).then((compressedFile) => {
        formdata.append("image", compressedFile);
        formdata.append("category", selectedOptions.value);
        if (idindex) {
          formdata.append("_id", idindex);
          axios.put(`${Base_Url}/frame_categories`, formdata, { headers }).then((res) => {
            if (res.data !== null) {
              setloading(false);
              catgoryget();
              handleclear();
            }
          });
        } else {
          axios.post(`${Base_Url}/frame_categories`, formdata, { headers }).then((res) => {
            if (res.data !== null) {
              setloading(false);
              catgoryget();
              handleclear();
            }
          });
        }
      });
    }
  };


  const handleFile = (e) => {
    const selectedfile = e.target.files[[0]];
    // console.log(selectedfile);
    setfile(selectedfile);
  };

  const catagorydata = () => {
    axios.get(`${Base_Url}/categories`, { headers }).then((res) => {
      // console.log(res.data.data);
      setCatdata(res.data.data);
    });
  };

  const catgoryget = () => {
    axios.get(`${Base_Url}/frame_categories`, { headers }).then((res) => {
      setCategories(res.data.data);
    });
  };
  useEffect(() => {
    catgoryget();
    catagorydata();
  }, []);

  useEffect(() => {
    if (categories) {
      setFilteredCategories(categories);
    }
  }, [categories]);

  const handleedit = (e, id) => {
    e.preventDefault();
    let filteredData = categories.filter((cat) => cat._id === id);
    console.log(filteredData);

    console.log("id", id);
    filteredData = filteredData[0];

    setidindex(filteredData._id);
    seteditimg(filteredData.image);
    setname(filteredData.name);

    // Update the selected category in the state
    const selectedCategoryId = filteredData?.category;
    const selectedCategory = catdata.find(
      (item) => item?._id === selectedCategoryId
    );
    setSelectedOptions({
      value: selectedCategory?._id,
      label: selectedCategory?.name,
    });
    // console.log("data", categories[id]);
  };

  const options = catdata.map((item) => ({
    value: item._id,
    label: item.name,
  }));

  const getRowId = (row) => row._id;
  const columns = [
    { field: "name", headerName: "Name", flex: 1 },
    { field: "category", headerName: "Category", flex: 1 },

    {
      field: "image",
      headerName: "image",
      flex: 1,
      renderCell: (params) => {
        const { value } = params;
        return (
          <img
            src={`${Base_Url}/${value}`}
            onClick={(e) => handleShow(e, value)}
            style={{
              width: "45px",
              height: "45px",
              borderRadius: "50%",
            }}
            className="img-fluid tableimgmui"
          ></img>
        );
      },
    },

    {
      field: "edit",
      headerName: "Edit",
      flex: 1,
      renderCell: (params) => {
        const index = params.row.index;
        const id = params.row._id; // Corrected to rowIndex
        return (
          <span
            style={{ cursor: "pointer" }}
            onClick={(e) => handleedit(e, id)}
          >
            <i className="fa-solid fa-pen-to-square"></i>
          </span>
        );
      },
    },
    {
      field: "delete",
      headerName: "Delete",
      flex: 1,
      renderCell: (params) => {
        const index = params.row.index;
        const id = params.row._id; // Corrected to rowIndex
        return (
          <span
            style={{ cursor: "pointer" }}
            onClick={(e) => {
              handleDelete(e, id);
            }}
          >
            <i className="fa-solid fa-trash"></i>
          </span>
        );
      },
    },
  ];

  const notify = (message, type) => {
    // console.log("type", type);
    toast[type](message, {
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const handleDelete = (e, id) => {
    e.preventDefault();

    let requestdata = {
      _id: id,
      deleted_at: Math.floor(Date.now() / 1000),
    };

    axios
      .put(`${Base_Url}/frame_categories`, requestdata, { headers })
      .then((res) => {
        // console.log(res);
        if (res.data.message === "Ok") {
          catgoryget();
          notify("Delete Successfully", "success");
          // console.log("Data", res.data);
        }
      })
      .catch((error) => {
        console.error("Error deleting:", error);
        notify("Error deleting", "error");
      });
  };

  const handleclear = () => {
    setname("");
    seteditimg(null);
    setfile("");
    setSelectedOptions(null);
  };

  const handlefilter = (e, selectedBrand) => {
    e.preventDefault();
    // console.log("selectebrand ", selectedBrand);
    setActiveBrand(selectedBrand);
    // Filter categories based on selected brand's category IDs
    const filteredData = categories.filter((category) => {
      if (Array.isArray(category.category)) {
        return category.category.some((cat) => cat === selectedBrand._id);
      } else {
        return category.category === selectedBrand._id;
      }
    });
    console.log(filteredData);

    setFilteredCategories(filteredData);
  };

  // const handlefilter = (e, selectedBrand) => {
  //   e.preventDefault();

  //   setActiveBrand(selectedBrand);
  //   // Filter categories based on selected brand's category IDs
  //   const filteredData = categories.filter((category) =>
  //     category.category.some((cat) => cat === selectedBrand._id)
  //   );
  //   setFilteredCategories(filteredData);
  // };

  return (
    <>
      {loading && (
        <div className="overlay">
          <Bars
            height="80"
            width="80"
            color="#051322"
            ariaLabel="bars-loading"
            visible={true}
          />
        </div>
      )}
      <Sidebaar
        content={
          <>
            <ToastContainer />
            <TitleComp title="Add Frame Category" />
            <Form className="my-5" onSubmit={(e) => handlesubmit(e)}>
              <div className="row">
                <Col md="4">
                  <FormGroup>
                    <label htmlFor="">Name</label>
                    <input
                      type="text"
                      value={name}
                      onChange={(e) => setname(e.target.value)}
                      className="form-control"
                    />
                  </FormGroup>
                </Col>
                {editimg && (
                  <Col md="1">
                    <div className="text-center">
                      <img
                        style={{ height: "100px" }}
                        src={`${Base_Url}/${editimg}`}
                        className="img-fluid rounded-2"
                      />
                    </div>
                  </Col>
                )}
                <Col md="4">
                  <FormGroup>
                    <label htmlFor="">Image</label>
                    <input
                      type="file"
                      onChange={(e) => handleFile(e)}
                      className="form-control"
                    />
                  </FormGroup>
                </Col>
                <Col md={idindex ? "3" : "4"}>
                  <label htmlFor="">Select Category</label>
                  <Select
                    options={options}
                    value={selectedOptions}
                    onChange={handleSelectChange}
                  />
                </Col>

                <Col md="2">
                  <button className="btn mt-4 bg-dark text-white">
                    Submit{" "}
                  </button>
                </Col>
              </div>
            </Form>

            <div className="row  align-items-center">
              <div className="col-md-10">
                <div className="d-flex gap-3 overflowscroll">
                  {catdata.map((item, index) => {
                    return (
                      <>
                        <button
                          key={index}
                          className={`btn px-5 rounded-pill ${activeBrand && activeBrand._id === item._id
                            ? " bgblackgrd text-white"
                            : "bgbluegrd text-white"
                            }`}
                          onClick={(e) => handlefilter(e, item)}
                        >
                          {item.name}
                        </button>
                      </>
                    );
                  })}
                </div>
              </div>
              <div className="col-md-2">
                <button
                  className="btn bg-dark text-white"
                  onClick={(e) => {
                    setFilteredCategories(categories);
                    setActiveBrand(null);
                  }}
                >
                  Show All
                </button>
              </div>
            </div>
            <Col md="12">
              <Box sx={{ height: 500, width: "100%" }}>
                <DataGrid
                  //   rows={data} // Update this line
                  // rows={categories.map((row, index) => ({
                  //   ...row,
                  //   index,
                  // }))}
                  rows={filteredCategories.map((row, index) => ({
                    ...row,
                    index,
                  }))}
                  columns={columns}
                  pageSize={5}
                  getRowId={getRowId}
                  initialState={{
                    pagination: { paginationModel: { pageSize: 10 } },
                  }}
                  pageSizeOptions={[5, 10, 25]}
                />
              </Box>
            </Col>



            <Modal show={show} size="md" onHide={handleClose}>
              <Modal.Header closeButton>
                <Modal.Title>Image</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <img src={`${Base_Url}/${imageurl}`} alt="" />
              </Modal.Body>
              <Modal.Footer>
                <Button className="text-write bg-secondary  shadow-none border-0" onClick={handleClose}>
                  Close
                </Button>
              </Modal.Footer>
            </Modal>
          </>
        }
      />
    </>
  );
}

export default FrameCategory;
